"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.number.constructor");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _argumentContracts = _interopRequireDefault(require("argument-contracts"));

var _axisLabelFormatters = require("../../label-formatters/axis-label-formatters");

var _styles = require("../../styles");

var _getValidObject = _interopRequireDefault(require("../../get-valid-object"));

var _isHexColorValue = _interopRequireDefault(require("../../is-hex-color-value"));

var _legendClickHandlers = require("../../legend-click-handlers");

var _tooltipFormatters = require("../../tooltip-formatters");

var _mwNoop = require("../../mw-noop");

var DEFAULT_DATALABEL_FORMATTER = function DEFAULT_DATALABEL_FORMATTER() {};

var DEFAULT_HIDE_LEGEND = false;
var DEFAULT_HIDDEN_SERIES_INDICES = [];
var DEFAULT_LEGEND_CLICK_HANDLER = undefined;
var DEFAULT_POINT_CLICK_HANDLER = _mwNoop.NOOP;
var DEFAULT_TOOLTIP_FORMATTER = undefined;
var DEFAULT_X_AXIS_LABEL_FORMATTER = _axisLabelFormatters.AxisLabelFormatters.PASS_THROUGH;
var DEFAULT_Y_AXIS_LABEL_FORMATTER = _axisLabelFormatters.AxisLabelFormatters.DEFAULT_NUMBER_LABEL;
/**
 * @callback MwChartGroupedColumnAxisLabelFormatter
 *
 * Custom behavior to format the label for a particular mark on the x-axis.
 *
 * @param {AxisLabelFormatterOptions} options Options provided by the chart
 * @returns {string} Text to show as the x-axis label
 */

/**
 * @callback MwChartGroupedColumnOnPointClick
 *
 * @param {NSeriesPointClickOptions} - Passed NSeriesPointClickOptions
 * @returns {function}
 */

/**
 * A class to represent the visualization options for a MwChartGroupedColumnOptions Chart
 *
 * @param {object} options options object (See below)
 * @param {boolean} [options.animate=true] Dictate whether to animate the chart when rendering
 * @param {boolean} [options.areDataLabelsVisible=false] - Dictate whether to show labels on the points of the chart
 * @param {function} [options.dataLabelFormatter] A function to be passed a value to format data label
 * @param {number[]} [options.hiddenSeriesIndices] An array of series indices to hide from display on the chart. Defaults to an empty array
 * @param {boolean} [options.hideLegend] Dictate whether to display the chart legend
 * @param {function|LegendClickHandlers} [options.onLegendClick] Function to handle the OnLegendClick event, or a valid LegendClickHandlers string
 * @param {MwChartGroupedColumnOnPointClick} [options.onPointClick] - A function to be passed a column data object (ie seriesIndex, seriesName, value) on click
 * @param {string[]} [options.seriesColors] An array of colors for MwChartGroupedColumnOptions
 * @param {function} [options.tooltipFormatter] Custom handler to format tooltips
 * @param {MwChartGroupedColumnAxisLabelFormatter|AxisLabelFormatters} [options.xAxisLabelFormatter=AxisLabelFormatters.PASS_THROUGH] A function to format x-axis labels, or a named AxisLabelFormatter. If provided a function, the function is provided AxisLabelFormatterOptions.
 * @param {MwChartGroupedColumnAxisLabelFormatter|AxisLabelFormatters} [options.yAxisLabelFormatter=AxisLabelFormatters.DEFAULT_NUMBER_LABEL] A function to format y-axis labels, or a named AxisLabelFormatter. If provided a function, the function is provided AxisLabelFormatterOptions.
 * @param {string} [options.yAxisTitle] The Y Axis title text
 */

var MwChartGroupedColumnOptions = // eslint-disable-next-line complexity
function MwChartGroupedColumnOptions(options) {
  (0, _classCallCheck2.default)(this, MwChartGroupedColumnOptions);
  var safeOptions = (0, _getValidObject.default)(options);

  if (safeOptions.animate === undefined) {
    safeOptions.animate = true;
  } else {
    _argumentContracts.default.assertBoolean(safeOptions.animate, 'options.animate');
  }

  if (safeOptions.areDataLabelsVisible === undefined) {
    safeOptions.areDataLabelsVisible = false;
  } else {
    _argumentContracts.default.assertBoolean(safeOptions.areDataLabelsVisible, 'options.areDataLabelsVisible');
  }

  if (safeOptions.dataLabelFormatter === undefined) {
    safeOptions.dataLabelFormatter = DEFAULT_DATALABEL_FORMATTER;
  } else if (typeof safeOptions.dataLabelFormatter !== 'function') {
    throw new TypeError("options.dataLabelFormatter must be a function. Provided value: ".concat(JSON.stringify(safeOptions.dataLabelFormatter)));
  }

  if (safeOptions.hideLegend === undefined) {
    safeOptions.hideLegend = DEFAULT_HIDE_LEGEND;
  } else {
    _argumentContracts.default.assertBoolean(safeOptions.hideLegend, 'safeOptions.hideLegend');
  }

  if (safeOptions.hiddenSeriesIndices === undefined) {
    safeOptions.hiddenSeriesIndices = DEFAULT_HIDDEN_SERIES_INDICES;
  } else {
    _argumentContracts.default.assertArrayOf(safeOptions.hiddenSeriesIndices, Number, 'options.hiddenSeriesIndices');
  }

  if (safeOptions.onLegendClick === undefined) {
    safeOptions.onLegendClick = DEFAULT_LEGEND_CLICK_HANDLER;
  } else if (typeof safeOptions.onLegendClick === 'string') {
    if (!(0, _legendClickHandlers.isValidLegendClickHandler)(safeOptions.onLegendClick)) {
      throw new TypeError("options.onLegendClick must be a valid LegendClickHandlers if provided as a string. Provided: ".concat(safeOptions.onLegendClick));
    }
  } else if (typeof safeOptions.onLegendClick !== 'function') {
    throw new TypeError("options.onLegendClick must be a function. Provided value: ".concat(JSON.stringify(safeOptions.onLegendClick)));
  }

  if (safeOptions.onPointClick === undefined) {
    safeOptions.onPointClick = DEFAULT_POINT_CLICK_HANDLER;
  } else if (typeof safeOptions.onPointClick !== 'function') {
    throw new TypeError("options.onPointClick must be a function. Provided value: ".concat(safeOptions.onPointClick));
  }

  if (safeOptions.seriesColors === undefined) {
    safeOptions.seriesColors = _styles.DEFAULT_SERIES_CHART_COLORS;
  } else if (!Array.isArray(safeOptions.seriesColors) || !safeOptions.seriesColors.every(function (color) {
    return (0, _isHexColorValue.default)(color);
  })) {
    throw new TypeError("options.seriesColors must be an array of hex colors. Provided value: ".concat(JSON.stringify(safeOptions.seriesColors)));
  }

  if (safeOptions.tooltipFormatter === undefined) {
    safeOptions.tooltipFormatter = DEFAULT_TOOLTIP_FORMATTER;
  } else if (typeof safeOptions.tooltipFormatter === 'string') {
    if (!(0, _tooltipFormatters.isValidTooltipFormatter)(safeOptions.tooltipFormatter)) {
      throw new TypeError("options.tooltipFormatter must be a recognized TooltipFormatter if a string is provided. Provided value: ".concat(safeOptions.tooltipFormatter));
    }
  } else {
    _argumentContracts.default.assertFunction(safeOptions.tooltipFormatter, 'options.tooltipFormatter');
  }

  if (safeOptions.xAxisLabelFormatter === undefined) {
    safeOptions.xAxisLabelFormatter = DEFAULT_X_AXIS_LABEL_FORMATTER;
  } else if (typeof safeOptions.xAxisLabelFormatter === 'string') {
    if (!(0, _axisLabelFormatters.isValidAxisLabelFormatter)(safeOptions.xAxisLabelFormatter)) {
      throw new TypeError("options.xAxisLabelFormatter must be a recognized AxisLabelFormatter if a string is provided. Provided value: ".concat(safeOptions.xAxisLabelFormatter));
    }
  } else {
    _argumentContracts.default.assertFunction(safeOptions.xAxisLabelFormatter, 'options.xAxisLabelFormatter');
  }

  if (safeOptions.yAxisLabelFormatter === undefined) {
    safeOptions.yAxisLabelFormatter = DEFAULT_Y_AXIS_LABEL_FORMATTER;
  } else if (typeof safeOptions.yAxisLabelFormatter === 'string') {
    if (!(0, _axisLabelFormatters.isValidAxisLabelFormatter)(safeOptions.yAxisLabelFormatter)) {
      throw new TypeError("options.yAxisLabelFormatter must be a recognized AxisLabelFormatter if a string is provided. Provided value: ".concat(safeOptions.yAxisLabelFormatter));
    }
  } else {
    _argumentContracts.default.assertFunction(safeOptions.yAxisLabelFormatter, 'options.yAxisLabelFormatter');
  }

  if (safeOptions.yAxisTitle !== undefined) {
    _argumentContracts.default.assertString(safeOptions.yAxisTitle, 'options.yAxisTitle');
  }

  this.animate = safeOptions.animate;
  this.areDataLabelsVisible = safeOptions.areDataLabelsVisible;
  this.dataLabelFormatter = safeOptions.dataLabelFormatter;
  this.hideLegend = safeOptions.hideLegend;
  this.hiddenSeriesIndices = safeOptions.hiddenSeriesIndices;
  this.onLegendClick = safeOptions.onLegendClick;
  this.onPointClick = safeOptions.onPointClick;
  this.seriesColors = safeOptions.seriesColors;
  this.tooltipFormatter = safeOptions.tooltipFormatter;
  this.xAxisLabelFormatter = safeOptions.xAxisLabelFormatter;
  this.yAxisLabelFormatter = safeOptions.yAxisLabelFormatter;
  this.yAxisTitle = safeOptions.yAxisTitle;
  Object.freeze(this);
};

exports.default = MwChartGroupedColumnOptions;